import NumeroTicket from "./NumeroTicket";
import { Container, Col } from "react-bootstrap";

const styles = {
    wrapper: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center"
    },
    h1: {
        color: "var(--color-background)",
        fontSize: "clamp(2rem, 5rem, 6vh)",
        fontWeight: "bold"
    },
    h2: {
        color: "var(--color-background)",
        fontSize: "clamp(1.5rem, 3rem, 4vh)",
        fontWeight: "semibold"
    }
};

function TurnoActual({ numero, modulo }) {
    return (
        <Container fluid className="p-0 m-0" >
            <Col md={12} lg={12} className="my-auto" style={styles.wrapper}>
                <h1 style={styles.h1}> Es tu turno </h1>
                <NumeroTicket numero={numero}/>
                <h2 style={styles.h2}> Dirígete al</h2>
                <h1 style={styles.h1}>Mesón {modulo} </h1>
            </Col>
        </Container>
    );
}

export default TurnoActual;
